module.exports = __webpack_public_path__ + "static/media/carousel_img1.4c166e56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/carousel_img1.jpg
// module id = 363
// module chunks = 0